// Predicates for the AllVisits admin-toolbar "E-post" bulk action. An invoice sale
// qualifies for email sending when it has not already been emailed. A sent invoice
// email is recorded on the sale BOTH as `sentEmailDate` and as an entry in
// `reminders` (get-sale-email-reminder / -friendly-reminder / -priceoffer all stamp
// both), so either marker means "already sent". Kept as a pure module so the wizard
// count (computed in render), the bulk send loop, the row indicator and the
// readiness check in allVisitsTable.js share one definition — and so it can be
// unit tested without importing the component.
export function isInvoiceSaleReadyForEmail(sale) {
    if (!sale || sale.paymentMethod !== 'invoice') {
        return false;
    }
    if (sale.sentEmailDate) {
        return false;
    }
    const hasReminders = Array.isArray(sale.reminders) && sale.reminders.length > 0;
    return !hasReminders;
}

// The date an email was last sent for this sale, or null if never sent.
// Prefers `sentEmailDate`; falls back to the newest `reminders` entry
// ($addToSet appends, so the last entry is the most recent).
export function invoiceSaleEmailSentDate(sale) {
    if (!sale) {
        return null;
    }
    if (sale.sentEmailDate) {
        return sale.sentEmailDate;
    }
    if (Array.isArray(sale.reminders) && sale.reminders.length > 0) {
        const dates = sale.reminders.map(r => r && r.date).filter(Boolean);
        if (dates.length > 0) {
            return dates[dates.length - 1];
        }
    }
    return null;
}

export default isInvoiceSaleReadyForEmail;
